const AI_ERROR_UNKNOWN = "Unbekannt";

export const formatSupabaseError = (err) => {
  const code = String(err?.code || "").trim();
  const message = String(err?.message || err?.details || err?.hint || "").trim();
  if (!code && !message) return AI_ERROR_UNKNOWN;
  return [code, message].filter(Boolean).join(": ");
};

export const deriveChangedRange = (previousText, nextText) => {
  if (previousText === nextText) {
    return { start: 0, end: nextText.length };
  }

  let start = 0;
  while (
    start < previousText.length &&
    start < nextText.length &&
    previousText[start] === nextText[start]
  ) {
    start += 1;
  }

  let previousEnd = previousText.length - 1;
  let nextEnd = nextText.length - 1;
  while (
    previousEnd >= start &&
    nextEnd >= start &&
    previousText[previousEnd] === nextText[nextEnd]
  ) {
    previousEnd -= 1;
    nextEnd -= 1;
  }

  return { start, end: Math.max(start, nextEnd + 1) };
};
